<template>
  <div>
    <div class="textWrapper">
      <h2 class="sectionTitle" data-aos="fade-up" data-aos-offset="50">
        Як усе<br class="br" />
        відбуватиметься
      </h2>
    </div>
    <div class="infoItemsWrapper">
      <div class="infoTextWrapper" data-aos="fade-up" data-aos-offset="100">
        <div class="infoText-wrapper">
          <span class="text13"
            >Відповідно до ваших критеріїв, ми відбираємо учасників серед
            зареєстрованих студентів та супроводжуємо їх протягом підготовки та
            проведення події.</span
          >
        </div>
      </div>
      <div class="infoTextWrapper" data-aos="fade-up" data-aos-offset="100">
        <div class="infoText-wrapper">
          <span class="text13"
            >Протягом кількох годин ви проводите екскурсію, воркшопи, панельні
            дискусії, speed datings, розіграші чи інші активності, націлені на
            ознайомлення студентів з вашою компанією, надання їм різнопрофільних
            навичок та досвіду.</span
          >
        </div>
        <div class="infoButtonWrapper">
          <InfoButton @click="changeTimetablePopupState(true)" />
        </div>
      </div>
      <div class="infoTextWrapper" data-aos="fade-up" data-aos-offset="100">
        <div class="infoText-wrapper">
          <span class="text13"
            >Як результат, ви покращите відносини зі студентами, познайомите їх
            із вашою компанією, покажете внутрішні процеси та атмосферу, надасте
            їм актуальні знання та досвід.</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoButton from '../../../../components/InfoButton.vue';

export default {
  name: 'Description',
  components: {
    InfoButton
  },
  methods: {
    changeTimetablePopupState(payload) {
      document.body.classList.toggle('hiddenOverflow');
      document.querySelector('.blurred').classList.toggle('active');
      this.$store.commit('changeTimetablePopupState', payload);
    }
  }
};
</script>

<style lang="scss" scoped>
.textWrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 3.82em;
}

.infoItemsWrapper {
  display: flex;
  justify-content: space-between;
  gap: 2.552rem;
}

.infoTextWrapper {
  flex-direction: column;
  border: solid 2px #4f388d;
  padding: 1.793rem 2.897rem;
  background-color: white;
  width: 23.333rem;
  position: relative;
}

.infoButtonWrapper {
  position: absolute;
  right: 3%;
  bottom: 4%;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .br {
    display: none;
  }
  .textWrapper {
    margin-bottom: 8.125rem;
  }
  .infoItemsWrapper {
    display: flex;
    flex-direction: column;
    gap: 9.375rem;
  }
  .infoTextWrapper {
    width: auto;
  }

  .infoText-wrapper {
    line-height: 1.5em;
    width: auto;
    margin-bottom: 8.125rem;
  }
  .infoText {
    font-size: 3.75rem;
    line-height: 4.68rem;
  }
}
</style>
